import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Favoritos.types';
import { IFavoritosPantalla } from './Favoritos.lib';
import moment from 'moment';
import { Cliente } from '@/__env/lib/Clientes';
import { Viajante } from '@/__env/lib/Ventas/Viajantes';
import { Articulo } from '@/__env/lib/Articulos';

export class FavoritosPantalla extends IFavoritosPantalla
{

    public static async create(): Promise<FavoritosPantalla[]>
    {
        return await FavoritosPantalla.find();
    }


    static Route: string = '/pant/favoritos';
    protected static async find(): Promise<FavoritosPantalla[]>
    {
        let request = new apiRequest();
        request.path = `${FavoritosPantalla.Route}`;
        if ( await request.get() )
        {
            return request.data.results.map( ( x: any ) => new FavoritosPantalla( x ) );
        }
        return [];
    }

    static async test(): Promise<any>
    {
        let request = new apiRequest();
        request.path = `/me`;
        if ( await request.get() )
        {
            console.log( request.data );
        }
        return [];
    }

    public static async crear( tipo: string, id: string ): Promise<boolean>
    {

        try
        {
            let req = new apiRequest();
            req.body = {
                tipo: tipo,
                codigo: id,
            };
            req.path = `${FavoritosPantalla.Route}`;
            if ( await req.post() )
            {
                return true;
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public static async eliminar( tipo: string, id: string ): Promise<boolean>
    {

        try
        {
            let req = new apiRequest();
            req.body = {
                tipo: tipo,
                codigo: id,
            };
            req.path = `${FavoritosPantalla.Route}`;
            if ( await req.delete() )
            {
                return true;
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public static async Clientes( fav: FavoritosPantalla[] ): Promise<Cliente[]>
    {
        let cc: Cliente[] = [];
        for ( let favi of fav.filter( x => x.Tipo == 'cliente' ) )
        {
            cc.push( await Cliente.create( Number( favi.Codigo ) ) );
        }
        return cc;
    }

    public static async Viajantes( fav: FavoritosPantalla[] ): Promise<Viajante[]>
    {
        let cc: Viajante[] = [];
        for ( let favi of fav.filter( x => x.Tipo == 'viajante' ) )
        {
            cc.push( await Viajante.create( Number( favi.Codigo ) ) );
        }
        return cc;
    }

    public static async Articulos( fav: FavoritosPantalla[] ): Promise<Articulo[]>
    {
        let cc: Articulo[] = [];
        for ( let favi of fav.filter( x => x.Tipo == 'articulo' ) )
        {
            cc.push( await Articulo.create( favi.Codigo ) );
        }
        return cc;
    }
}